import { useMasters } from "@/hooks/useMasters";

// FG Code is the single product key across Plan / Production / Dispatch / Kits / DA-DP.
export const fgOf = (customers, r) => {
  if (!r) return "";
  if (r.fg_code) return r.fg_code;
  const list = customers || [];
  const byId = r.customer_id && list.find((c) => c.id === r.customer_id);
  if (byId?.fg_code) return byId.fg_code;
  const name = (r.model_name || r.model || "").trim().toLowerCase();
  const bySku = r.sku && list.find((c) => c.sku && c.sku.toLowerCase() === String(r.sku).toLowerCase());
  if (bySku?.fg_code) return bySku.fg_code;
  const byModel = name && list.find((c) => (c.model || "").toLowerCase() === name || (c.fg_code || "").toLowerCase() === name);
  return byModel?.fg_code || "";
};

export const productLabel = (c) => (c ? `${c.fg_code || "—"} · ${c.customer}${c.model && c.model !== c.fg_code ? ` · ${c.model}` : ""}${c.colour ? ` · ${c.colour}` : ""}` : "");

// Inline product cell: FG code (bold) with customer/model as secondary text.
export function Prod({ r, customer = true, className = "" }) {
  const { masters } = useMasters();
  const fg = fgOf(masters.customers, r);
  const model = r?.model_name || r?.model || "";
  return (
    <span className={`inline-flex flex-col leading-tight ${className}`}>
      <span className="font-mono font-semibold text-blue-900">{fg || model || "—"}</span>
      <span className="text-[10px] text-slate-500">{[customer && (r?.customer_name || r?.customer), fg && model && model !== fg ? model : null].filter(Boolean).join(" · ")}</span>
    </span>
  );
}
